interface CustomerOption {
    id: string;
    text: string;
}

interface CustomerOptionsResponse {
    results: CustomerOption[];
    pagination: { more: boolean };
}

class CustomerSearchSelect {
    constructor(select: JQuery<HTMLElement>) {
        (select as any).select2({
            width: "100%",
            allowClear: true,
            placeholder: select.data("placeholder"),
            ajax: {
                url: select.data("url"),
                dataType: "json",
                delay: 250,
                data: (params: { term?: string; page?: number }) => ({
                    term: params.term || "",
                    page: params.page || 1
                }),
                processResults: (data: CustomerOptionsResponse) => data
            }
        });
    }
}

export function LoadPage(): void {
    $(() => {
        $(".customer-search-select").each((_index, element) => {
            new CustomerSearchSelect($(element));
        });
    });
}
